import { useClickAway, useMedia } from 'react-use'
import styled from 'styled-components'
import { faXmark, IconDefinition } from '@fortawesome/free-solid-svg-icons'
import React, { useRef, useState } from 'react'

import { ButtonVariants } from './buttonVariants'

const Wrapper = styled.aside<{
  $isMobile: boolean
  $isOpen: boolean
  $top?: number
  $bottom?: number
}>`
  position: ${({ $isMobile }) => ($isMobile ? 'relative' : 'absolute')};
  ${({ $isMobile, theme }) =>
    $isMobile ? `left: ${theme.padding(1)};` : `right: ${theme.padding(1)};`}
  bottom: ${({ $bottom }) => ($bottom ? `${$bottom}px` : '0')};
  top: ${({ $top, $isMobile }) => ($isMobile ? 'auto' : $top ? `${$top}px` : '0')};

  .layer {
    max-height: 100%;
    height: 100%;
    background-color: white;
    width: ${({ $isMobile }) => ($isMobile ? '80vw' : '20vw')};
    min-width: ${({ $isMobile }) => ($isMobile ? 'auto' : '335px')};
    border-radius: ${({ theme }) => theme.borderRadius};
    box-shadow: ${({ theme }) => theme.shadow(1)};
    overflow: hidden;

    @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
      background-color: ${({ theme }) => theme.backdropBackground};
      -webkit-backdrop-filter: ${({ theme }) => theme.backdropFilter};
      backdrop-filter: ${({ theme }) => theme.backdropFilter};
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
      opacity: ${({ $isOpen }) => ($isOpen ? '1' : '0')};
      transform: translateY(${({ $isOpen }) => ($isOpen ? '0' : '50px')});
      visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
      transition:
        opacity 0.3s ease-in-out,
        transform 0.3s ease-in-out,
        visibility 0.3s ease-in-out;
      max-width: 300px;
      max-height: 80vh;
      height: auto;

      position: absolute;
      left: calc(40px + ${({ theme }) => theme.padding(1)});
      bottom: 0px;
    }
  }
`

const ButtonMobile = styled(ButtonVariants)`
  width: 40px;
  height: 40px;
  box-shadow: ${({ theme }) => theme.shadow(1)};
  transition: box-shadow 0.2s ease-in-out;
  &:hover {
    box-shadow: ${({ theme }) => theme.shadow(2)};
  }
`

type ListInformationWrapperProps = {
  icon: IconDefinition
  children: React.ReactNode
  top?: number
  bottom?: number
}

export const ListInformationWrapper = ({
  icon,
  children,
  top,
  bottom,
}: ListInformationWrapperProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const ref = useRef(null)
  const isMobile = useMedia(`(max-width: 768px)`)

  useClickAway(ref, () => {
    if (isMobile && isOpen) {
      setIsOpen(prevData => !prevData)
    }
  })

  const handleIcon = () => {
    if (isOpen) {
      return faXmark
    }
    return icon
  }

  return (
    <Wrapper ref={ref} $isOpen={isOpen} $isMobile={isMobile} $top={top} $bottom={bottom}>
      {isMobile && (
        <ButtonMobile
          icon={handleIcon()}
          onClick={() => setIsOpen(prevData => !prevData)}
          variant='light'
          size='lg'
        />
      )}
      <main className='layer'>{children}</main>
    </Wrapper>
  )
}
